






import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
const setting = namespace("setting");

@Component({})
export default class ShowPicking extends Vue {
  @setting.State serviceMode;
  // MODE_S(1,"标准模式"),
  // MODE_A(2,"快捷模式 A"),
  // MODE_B(3,"快捷模式 B")

  // example [0,1] 订单状态为0，结算状态1
  @Prop({ default: () => ({}) })
  orderData: any;
  get $show() {
    if (this.orderData.orderType !== "1") {
      return false;
    }
    if (this.serviceMode === "1") {
      if (this.orderData.orderStatus === "2" && this.orderData.arrivalShop && this.orderData.outboundNo) {
        return true;
      }
    }
    return false;
  }
}
